import { useCallback } from 'react';
import { createFilterOptions } from '@mui/base/useAutocomplete';
import { useIntlBds } from '../../../translations/BdsIntlProvider';
import { TagOption } from './Tags.types';

export const filterOptions = createFilterOptions<TagOption>({
  ignoreAccents: true,
  ignoreCase: true,
  trim: true,
  matchFrom: 'any',
  stringify: (option) => option.label + option.label.replace(/ /g, '')
});

export const useGetTagError = ({
  values,
  error,
  errorText,
  maxTagsAmount
}: {
  values: string[] | undefined;
  maxTagsAmount: number | undefined;
  error: boolean | undefined;
  errorText: string | undefined;
}) => {
  const { format, intl } = useIntlBds();

  const valueLength = values?.length ?? 0;
  const hasLimitTagError = !!values && !!maxTagsAmount && valueLength > maxTagsAmount;
  const hasError = error || hasLimitTagError;

  const errorTextToDisplay = useCallback(() => {
    if (error && errorText) return errorText;
    if (hasLimitTagError) {
      return format(intl.Tags.exceedLimitError, {
        noToRemove: (valueLength - maxTagsAmount).toString(),
        maxTagsAmount: maxTagsAmount.toString()
      });
    }
    return errorText;
  }, [error, errorText, format, hasLimitTagError, intl.Tags.exceedLimitError, maxTagsAmount, valueLength]);

  return {
    hasError,
    errorTextToDisplay: errorTextToDisplay()
  };
};
